import React, { useContext, useEffect, useMemo, useState } from "react";
import { BsFillInfoCircleFill } from "react-icons/bs";

import img_yebo_na01 from "../../../images/img_yebo_na01.png";
import img_yebo_na02 from "../../../images/img_yebo_na02.png";
import img_yebo_na03 from "../../../images/img_yebo_na03.png";
import img_yebo_na04 from "../../../images/img_yebo_na04.png";
import img_yebo_na05 from "../../../images/img_yebo_na05.png";
import DataContext from "../../../context/users/DataContextCopy";
import dayjs from "dayjs";

function Forecast() {
  const { forecast, todayData, tomorrowData } = useContext(DataContext);
  const today = dayjs().format("YYYY-MM-DD");
  const tomorrow = dayjs().add(1, "day").format("YYYY-MM-DD");
  const getLatestDataTime = (forecastData) => {
    if (!forecastData || forecastData.length === 0) return null;

    // 최신값 기준으로 정렬
    const sortedData = forecastData.sort((a, b) =>
      dayjs(b.dataTime, "YYYY-MM-DD HH시 발표").diff(
        dayjs(a.dataTime, "YYYY-MM-DD HH시 발표")
      )
    );

    // 최신 데이터의 dataTime 반환
    return sortedData[0]?.dataTime || null;
  };
  // console.log(todayData);
  const latestPM10DataTime = getLatestDataTime(forecast["PM10"]);

  const [o3Img, setO3Img] = useState(0);
  const [pm10Img, setPm10Img] = useState(0);
  const [pm25Img, setPm25Img] = useState(0);

  const pm25Images = useMemo(() => {
    const images = [];
    const dataArr = [todayData["PM25"], tomorrowData["PM25"]];
    dataArr.forEach((data) => {
      if (data) {
        for (let i = 4; i <= 6; i++) {
          const imageUrl = data[`imageUrl${i}`];
          if (imageUrl) {
            images.push(imageUrl);
          }
        }
      }
    });
    return images.length > 0 ? images : "-";
  }, [todayData, tomorrowData]);

  const pm10Images = useMemo(() => {
    const images = [];
    const dataArr = [todayData["PM10"], tomorrowData["PM10"]];
    dataArr.forEach((data) => {
      if (data) {
        for (let i = 1; i <= 3; i++) {
          const imageUrl = data[`imageUrl${i}`];
          if (imageUrl) {
            images.push(imageUrl);
          }
        }
      }
    });
    return images.length > 0 ? images : "-";
  }, [todayData, tomorrowData]);

  const o3Images = useMemo(() => {
    const images = [];
    const dataArr = [todayData["O3"], tomorrowData["O3"]];
    dataArr.forEach((data) => {
      if (data) {
        for (let i = 1; i <= 5; i++) {
          const imageUrl = data[`imageUrl${i}`];
          if (imageUrl) {
            images.push(imageUrl);
          }
        }
      }
    });
    return images.length > 0 ? images : "-";
  }, [todayData, tomorrowData]);

  const getGradeImage = (__grade__) => {
    if (__grade__ === 1 || __grade__ === "좋음") {
      return img_yebo_na01;
    } else if (__grade__ === 2 || __grade__ === "보통") {
      return img_yebo_na02;
    } else if (__grade__ === 3 || __grade__ === "나쁨") {
      return img_yebo_na03;
    } else if (__grade__ === 4 || __grade__ === "매우나쁨") {
      return img_yebo_na04;
    }
    return img_yebo_na05;
  };

  useEffect(() => {
    const o3Interval = setInterval(() => {
      if (o3Images.length > 0) {
        setO3Img((prevIndex) => (prevIndex + 1) % o3Images.length);
      }
    }, 1000);

    const pm10Interval = setInterval(() => {
      if (pm10Images.length > 0) {
        setPm10Img((prevIndex) => (prevIndex + 1) % pm10Images.length);
      }
    }, 1000);

    const pm25Interval = setInterval(() => {
      if (pm25Images.length > 0) {
        setPm25Img((prevIndex) => (prevIndex + 1) % pm25Images.length);
      }
    }, 1000);

    return () => {
      clearInterval(o3Interval);
      clearInterval(pm10Interval);
      clearInterval(pm25Interval);
    };
  }, [o3Images, pm10Images, pm25Images]);
  return (
    <main className="forecast">
      <div className="title">
        <h1>대기오염 예보</h1>
      </div>

      <div className="span">
        <BsFillInfoCircleFill />
        <span>
          &nbsp; 예보는 05시, 11시, 17시 기준으로 에어코리아 발표자료입니다.
          <br />
          &nbsp; ※ 오존 예보 운영기간 : 매년 4월 15일~10월 15일
        </span>
        <br />
        <p>
          <BsFillInfoCircleFill />
          &nbsp; 기준 일시 : {latestPM10DataTime || "데이터 없음"}
        </p>
        <br />
        {forecast["PM10"] && forecast["PM10"].length > 0 ? (
          <strong>
            <BsFillInfoCircleFill />
            &nbsp; 오늘 예보등급 :
            {forecast["PM10"] &&
              forecast["PM10"].length > 1 &&
              forecast["PM10"][0]?.informOverall}
          </strong>
        ) : (
          ""
        )}
        <br />
        {forecast["O3"] && forecast["O3"].length > 0 ? (
          <strong>
            <BsFillInfoCircleFill />
            &nbsp; 오늘 오존등급 :
            {forecast["O3"] &&
              forecast["O3"].length > 1 &&
              forecast["O3"][0]?.informOverall}
          </strong>
        ) : (
          ""
        )}
      </div>

      <div className="foreTable">
        <div className="tableBox">
          <table>
            <thead>
              <tr style={{ borderBottom: "2px solid #ddd" }}>
                <th>구분</th>
                <th>오늘({today})</th>
                <th>내일({tomorrow})</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th>초미세먼지</th>
                <td>
                  {todayData["PM25"] ? (
                    <>
                      <img
                        src={getGradeImage(todayData["PM25"]?.informGrade)}
                        alt="초미세먼지등급"
                      />
                      <br />
                      {todayData["PM25"]?.informGrade}
                    </>
                  ) : (
                    "-"
                  )}
                </td>
                <td>
                  {tomorrowData["PM25"] ? (
                    <>
                      <img
                        src={getGradeImage(tomorrowData["PM25"]?.informGrade)}
                        alt="초미세먼지등급"
                      />
                      <br />
                      {tomorrowData["PM25"]?.informGrade}
                    </>
                  ) : (
                    "-"
                  )}
                </td>
              </tr>
              <tr>
                <th>미세먼지</th>
                <td>
                  {todayData["PM10"] ? (
                    <>
                      <img
                        src={getGradeImage(todayData["PM10"]?.informGrade)}
                        alt="미세먼지등급"
                      />
                      <br />
                      {todayData["PM10"]?.informGrade}
                    </>
                  ) : (
                    "-"
                  )}
                </td>
                <td>
                  {tomorrowData["PM10"] ? (
                    <>
                      <img
                        src={getGradeImage(tomorrowData["PM10"]?.informGrade)}
                        alt="미세먼지등급"
                      />
                      <br />
                      {tomorrowData["PM10"]?.informGrade}
                    </>
                  ) : (
                    "-"
                  )}
                </td>
              </tr>
              <tr>
                <th>오존</th>
                <td>
                  {todayData["O3"] ? (
                    <>
                      <img
                        src={getGradeImage(todayData["O3"]?.informGrade)}
                        alt="오존등급"
                      />
                      <br />
                      {todayData["O3"]?.informGrade}
                    </>
                  ) : (
                    "-"
                  )}
                </td>
                <td>
                  {tomorrowData["O3"] ? (
                    <>
                      <img
                        src={getGradeImage(tomorrowData["O3"]?.informGrade)}
                        alt="오존등급"
                      />
                      <br />
                      {tomorrowData["O3"]?.informGrade}
                    </>
                  ) : (
                    "-"
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="predict">
          <div className="h3">
            <h2>대기오염 농도 예측 모델</h2>
          </div>

          <div className="predictTable">
            <table>
              <thead>
                <tr>
                  <th>초미세먼지</th>
                  <th>미세먼지</th>
                  {o3Images !== "-" && <th>오존</th>}
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td data-label="초미세먼지" className="img">
                    {pm25Images[pm25Img] ? (
                      <img src={pm25Images[pm25Img]} alt="Slideshow" />
                    ) : null}
                  </td>
                  <td data-label="미세먼지" className="img">
                    {pm10Images[pm10Img] ? (
                      <img src={pm10Images[pm10Img]} alt="Slideshow" />
                    ) : null}
                  </td>
                  {o3Images !== "-" && (
                    <td data-label="오존" className="img">
                      {o3Images[o3Img] ? (
                        <img src={o3Images[o3Img]} alt="Slideshow" />
                      ) : null}
                    </td>
                  )}
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </main>
  );
}

export default Forecast;
